function escapeCsvValue(value) {
  const normalized = String(value ?? "");
  if (/[",\n]/.test(normalized)) {
    return `"${normalized.replace(/"/g, '""')}"`;
  }
  return normalized;
}

export function triggerDownload(blob, filename) {
  const safeName = filename?.trim() || "assistant-data.csv";
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = safeName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
}

export function downloadCsv({ columns, rows, filename }) {
  if (!Array.isArray(columns) || !columns.length) {
    return;
  }

  const header = columns.map((column) => escapeCsvValue(column.label ?? column.key)).join(",");
  const body = (Array.isArray(rows) ? rows : [])
    .map((row) => columns.map((column) => escapeCsvValue(row?.[column.key])).join(","))
    .join("\n");

  const csv = [header, body].filter(Boolean).join("\n");
  triggerDownload(new Blob([csv], { type: "text/csv;charset=utf-8;" }), filename);
}
